// Company IDs differ between the UAT and production databases, so each build reads them from its .env file.
// A missing value becomes NaN instead of 0, so it never matches the default companyId of 0.
const parseCompanyId = value => (value ? Number(value) : Number.NaN);

export const COMPANY_IDS = {
  INNOVATION: parseCompanyId(process.env.VUE_APP_INNOVATION_COMPANY_ID),
  PETRONAS: parseCompanyId(process.env.VUE_APP_PETRONAS_COMPANY_ID),
  MUNA: parseCompanyId(process.env.VUE_APP_MUNA_COMPANY_ID),
  NARAK: parseCompanyId(process.env.VUE_APP_NARAK_COMPANY_ID),
  YAMAHA: parseCompanyId(process.env.VUE_APP_YAMAHA_COMPANY_ID),
  KN: parseCompanyId(process.env.VUE_APP_KN_COMPANY_ID)
};
